/**
 * Kokochao V15 Alpha 2.3 — DOM-aware asset loader.
 * Loads progressive enhancement only when the corresponding storefront markup exists.
 */
(() => {
  'use strict';

  const loader = document.getElementById('KcV15AssetLoader');
  if (!loader) return;

  const productCardModule = loader.dataset.productCardModule || '';
  const productFormScript = loader.dataset.productFormScript || '';
  let productCardPromise = null;
  let productFormPromise = null;

  const loadProductCard = () => {
    if (customElements.get('kc-product-card')) return Promise.resolve();
    if (!productCardModule) return Promise.resolve();
    if (!productCardPromise) {
      productCardPromise = import(productCardModule).catch((error) => {
        productCardPromise = null;
        console.warn('[Kokochao V15] Product Card enhancement failed to load:', error);
      });
    }
    return productCardPromise;
  };

  const hasProductFormScript = () =>
    Boolean(customElements.get('product-form') || document.querySelector('script[src*="product-form.js"]'));

  const loadProductForm = () => {
    if (hasProductFormScript() || !productFormScript) return Promise.resolve();
    if (!productFormPromise) {
      productFormPromise = new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = productFormScript;
        script.defer = true;
        script.dataset.kcV15Loaded = 'product-form';
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', () => {
          productFormPromise = null;
          resolve();
        }, { once: true });
        document.head.appendChild(script);
      });
    }
    return productFormPromise;
  };

  const hydrate = (root = document) => {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    if (scope.querySelector?.('kc-product-card') || (scope instanceof Element && scope.matches('kc-product-card'))) {
      void loadProductCard();
    }
    if (
      scope.querySelector?.('kc-product-card product-form') ||
      (scope instanceof Element && scope.matches('kc-product-card') && scope.querySelector('product-form'))
    ) {
      void loadProductForm();
    }
  };

  hydrate(document);

  document.addEventListener('shopify:section:load', (event) => hydrate(event.target));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        const hasCard = node.matches('kc-product-card') || node.querySelector('kc-product-card');
        if (!hasCard) continue;
        hydrate(node);
        if (customElements.get('kc-product-card') && hasProductFormScript()) {
          observer.disconnect();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
